<template>
  <v-col cols="12">
    <template>
      <v-row justify="center">
        <v-dialog v-model="eliminar" persistent max-width="500px" :key="eliminar">
          <v-card>
            <v-card-title class="headline">¿Está seguro que desea eliminar este turno?</v-card-title>
            <v-card-text>Esta acción no se puede revertir y será permanente.</v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="eliminar = false; delItem = '';">Cancelar</v-btn>
              <v-btn color="red darken-1" text @click=" eliminar = false; deleteItemDB() ">Aceptar</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <v-data-table v-if=" permisoVista('turnos', 'r') " :headers=" headers " :items=" turnos " :search=" search "
      :loading=" loading " loading-text="Cargando... Espere, Por Favor.">
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-dialog v-model=" dialog " persistent max-width="600px" :key=" dialog ">
            <template v-slot:activator=" { on } ">
              <v-btn color="primary" dark class="mb-2" v-on=" on " v-if=" permisoVista('turnos', 'c') ">Nuevo
                Turno</v-btn>
            </template>
            <v-card>
              <v-card-title>
                <span class="headline">{{ formTitle }}</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field v-model=" editedItem.nombre " label="Nombre del Turno"></v-text-field>
                    </v-col>
                    <v-col justify="center" cols="12" sm="12" md="12">
                      <v-text-field v-model=" editedItem.codigo " label="Código de Turno" maxlength="8" />
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <input-time v-model="editedItem.inicio" label="Inicio" :max=" fin "></input-time>
                    </v-col>
                    <v-col cols="6" md="6" sm="6">
                      <input-time v-model="editedItem.fin" :min=" inicio " label="Fin"></input-time>
                    </v-col>
                    <v-col cols="12" md="12" sm="12">
                      <v-expansion-panels accordion>
                        <v-expansion-panel>
                          <v-expansion-panel-header>Horarios Adicionales</v-expansion-panel-header>
                          <v-expansion-panel-content>
                            <v-data-table :headers="horariosAdicionales" :items="editedItem.horarios" :items-per-page="5"
                              hide-default-footer class="elevation-1" dense>
                              <template v-slot:item="{ item }">
                                <tr>
                                  <td>
                                    <v-text-field v-model="item.nombreHorario"></v-text-field>
                                  </td>
                                  <td>
                                    <input-time v-model="item.inicio" :max="item.fin"></input-time>
                                  </td>
                                  <td>
                                    <input-time v-model="item.fin" :min="item.inicio"></input-time>
                                  </td>
                                  <td>
                                    <v-tooltip bottom color="black" class="white--text">
                                      <template v-slot:activator="{ on }">
                                        <v-icon v-on="on" small @click="RemoverLiberacionFase(item)">
                                          delete
                                        </v-icon>
                                      </template>
                                      <span class="white--text">Eliminar</span>
                                    </v-tooltip>
                                  </td>
                                </tr>
                                <tr v-if="item.errorActivo" style="font-size: 0.75em; padding-top: 0; margin-top: 0;">
                                  <td colspan="4" style="text-align: center;">
                                    <small class="error-message"
                                      style="color:red; font-size: 0.75em; padding: 0; margin: 0;">
                                      {{ item.errormessages }}
                                    </small>
                                  </td>
                                </tr>


                              </template>
                            </v-data-table>


                            <div class="text-center">
                              <v-btn small color="green" class="my-2" outlined @click="agregarLiberacionFase">Agregar
                                Horario</v-btn>
                            </div>
                          </v-expansion-panel-content>
                        </v-expansion-panel>
                      </v-expansion-panels>
                    </v-col>
                  </v-row>
                  <ul>
                    <li class="red--text" v-for="        ex         in         errores        " :key=" ex ">{{ ex }}
                    </li>
                  </ul>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click=" dialog = false; errores = []; ">Cancelar</v-btn>
                <v-btn color="red darken-1" text @click=" save() " :disabled=" saving " :loading=" saving ">
                  Guardar
                  <template v-slot:loader>
                    <v-progress-circular indeterminate :width=" 2 " :size=" 24 " color="red"></v-progress-circular>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-spacer></v-spacer>
          <v-text-field v-model=" search " append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-toolbar>
      </template>
      <template v-slot:item.action=" { item } ">
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator=" { on } ">
            <v-icon v-on=" on " v-if=" permisoVista('turnos', 'u') " small class="mr-2" @click=" editItem(item) ">
              edit
            </v-icon>
          </template>
          <span class="white--text">Editar</span>
        </v-tooltip>
        <v-tooltip bottom color="black" class="white--text">
          <template v-slot:activator=" { on } ">
            <v-icon v-on=" on " v-if=" permisoVista('turnos', 'd') " small @click=" deleteItem(item) ">
              delete
            </v-icon>
          </template>
          <span class="white--text">Eliminar</span>
        </v-tooltip>
      </template>
      <template v-slot:no-data>
        <v-btn color="primary" @click=" initialize ">Refrescar</v-btn>
      </template>
    </v-data-table>
    <v-snackbar v-model=" alerta " top color="error">
      Existe un Turno Activo con el mismo nombre
      <v-btn text @click=" alerta = false ">
        Cerrar
      </v-btn>
    </v-snackbar>
  </v-col>
</template>

<script>
import axios from "axios";
import inputTime from "@/components/InputTime";

export default {
  components: {
    'input-time': inputTime,
  },
  data: () => ({
    saving: false,
    dialog: false,
    alerta: false,
    eliminar: false,
    search: '',
    headers: [
      {
        text: 'Código',
        align: 'left',
        sortable: true,
        value: 'codigo',
      },
      {
        text: 'Turno',
        align: 'left',
        sortable: true,
        value: 'nombre',
      },
      {
        text: 'Inicio',
        align: 'left',
        sortable: true,
        value: 'inicio',
      },
      {
        text: 'Fin',
        align: 'left',
        sortable: true,
        value: 'fin',
      },
      { text: 'Acciones', value: 'action', sortable: false, width: '35%', align: 'center' },
    ],
    loading: false,
    turnos: [],
    delItem: '',
    action: 0,
    errores: [],
    editedIndex: -1,
    editedItem: {
      nombre: '',
      codigo: '',
      inicio: '',
      fin: '',
      horarios:[]
    },
    defaultItem: {
      nombre: '',
      codigo: '',
      inicio: '',
      fin: '',
      horarios:[]
    },
    horariosAdicionales:[
      {
        text: 'Descripción',
        align: 'center',
        sortable: false,
        value: 'nombreHorario',
      },
      {
        text: 'Inicio',
        align: 'center',
        sortable: false,
        value: 'inicio',
      },
      {
        text: 'Fin',
        align: 'center',
        sortable: false,
        value: 'fin'
      },
      { text: 'Acciones', value: 'action', sortable: false, align: 'center' },
    ],
    horarios:[],
    newIndex: 0,
    posicion: null,
    validado: false
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Nuevo Turno' : 'Editar Turno'
    }
  },

  watch: {
    dialog(val) {
      val || this.close()
    }
  },

  created() {
    this.initialize()
  },

  methods: {
    initialize() {
      let me = this;
      me.loading = true;
      axios
        .get("/Turnos")
        .then(response => {
          me.turnos = response.data;
          console.log(response.data)
          me.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },

    editItem(item) {
      this.action = 1;
      this.editedIndex = this.turnos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    deleteItem(item) {
      this.eliminar = true;
      this.delItem = item;
    },
    deleteItemDB() {
      let me = this;
      let item = this.delItem;
      this.delItem = '';
      axios
        .put("/Turnos/Desactivar/" + item.idTurno)
        .then(response => {
          me.initialize();
        })
        .catch(error => {
          console.log(error);
        });
    },
    close() {
      this.action = 0,
        this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    },
    validate() {
      this.errores = [];
      if ( this.editedItem.nombre.length < 2 || this.editedItem.nombre.length > 50) {
        this.errores.push("El nombre debe tener más de 2 caracteres y menos de 50.");
        return false;
      }

      if(this.validado){
        this.errores.push("Valida los datos ingresados en los horarios");
        return false;
      }
      return true;
    },
    save() {
      this.action = 0;
      this.reordenarPosiciones();
      this.validarRango();
      if (this.validate()) {
        let me = this;
        me.saving = true;
        if (this.editedIndex > -1) {
          //Código para editar
          axios
            .put("/Turnos/Actualizar/", {
              Codigo: me.editedItem.codigo == "" ? "" : me.editedItem.codigo,
              IdTurno: me.editedItem.idTurno,
              Nombre: me.editedItem.nombre,
              Inicio: me.editedItem.inicio,
              Fin: me.editedItem.fin,
              HorariosAdicionales: this.editedItem.horarios.map(a => ({
                idHorario: a.idHorario == null ? -1 : a.idHorario,
                idTurno: a.idTurno == null ? -1 : a.idTurno,
                nombre: a.nombreHorario,
                inicio: a.inicio,
                fin: a.fin
              }))
            })
            .then(response => {
              me.saving = false;
              me.close();
              me.initialize();
            })
            .catch(error => {
              me.saving = false;
              if (error.response) {
                if (error.response.status == 409) {
                  me.alerta = true;
                  me.errores.push("Existe un Turno Activo con el Mismo Nombre");
                }
              }
            });
        }
        else {
         
          axios
            .post("/Turnos/Crear", {
              Codigo: me.editedItem.codigo == "" ? "" : me.editedItem.codigo,
              Nombre: me.editedItem.nombre,
              Inicio: me.editedItem.inicio,
              Fin: me.editedItem.fin,
              HorariosAdicionales: this.editedItem.horarios.map(a => ({
                idHorario: -1,
                idTurno: -1,
                nombre: a.nombreHorario,
                inicio: a.inicio,
                fin: a.fin
              }))
            })
            .then(response => {
              me.saving = false;
              me.close();
              me.initialize();
            })
            .catch(error => {
              me.saving = false;
              if (error.response) {
                if (error.response.status == 409) {
                  me.alerta = true;
                  me.errores.push("Existe un Turno Activo con el Mismo Nombre");
                }
              }
            });
        }
      }
    },
    agregarLiberacionFase() {
      this.newIndex -= 1;
      var posicion =
        this.editedItem.horarios.map((a) => a.posicion).length == 0
          ? 0
          : Math.max(...this.editedItem.horarios.map((a) => a.posicion));
      this.posicion = posicion + 1;
      const newObj = JSON.parse(
        JSON.stringify({
          posicion: this.posicion,
          nombreHorario: null,
          inicio: null,
          fin: null,
          invalidado: false,
          errorActivo: false,
          errormessages: null
        })
      );
      this.editedItem.horarios.push(newObj);
      this.reordenarPosiciones();
      this.validarRango();
    },
    RemoverLiberacionFase(itemDelete) {
      console.log(itemDelete)
      console.log(this.editedItem.horarios)
      this.editedItem.horarios = this.editedItem.horarios.filter(
        (item) => JSON.stringify(item) != JSON.stringify(itemDelete)
      );
      this.reordenarPosiciones();
    },
    reordenarPosiciones() {
      this.editedItem.horarios.sort((a, b) => {
        // Comprobar si 'inicio' es nulo o vacío
        if (!a.inicio) return 1; // 'a' se considera mayor (se mueve al final)
        if (!b.inicio) return -1; // 'b' se considera menor (se queda en su lugar)

        const [aHoras, aMinutos] = a.inicio.split(':').map(Number);
        const [bHoras, bMinutos] = b.inicio.split(':').map(Number);
        const aTotalMinutos = aHoras * 60 + aMinutos;
        const bTotalMinutos = bHoras * 60 + bMinutos;
        return aTotalMinutos - bTotalMinutos;
    });
    },
    validarRango() {
      // Convertir los horarios de this.editedItem a minutos totales
      const [inicioEditedHoras, inicioEditedMinutos] = this.editedItem.inicio.split(':').map(Number);
      const [finEditedHoras, finEditedMinutos] = this.editedItem.fin.split(':').map(Number);
      const inicioEditedTotalMinutos = inicioEditedHoras * 60 + inicioEditedMinutos;
      const finEditedTotalMinutos = finEditedHoras * 60 + finEditedMinutos;

      this.editedItem.horarios.forEach(item => {
        // Solo proceder si 'inicio' y 'fin' son válidos
        if (item.inicio && item.fin) {
          const [inicioHoras, inicioMinutos] = item.inicio.split(':').map(Number);
          const [finHoras, finMinutos] = item.fin.split(':').map(Number);
          const inicioTotalMinutos = inicioHoras * 60 + inicioMinutos;
          const finTotalMinutos = finHoras * 60 + finMinutos;

          // Verificar si el horario está fuera del rango
          item.errorActivo = !(inicioTotalMinutos >= inicioEditedTotalMinutos && finTotalMinutos <= finEditedTotalMinutos);
          this.validado = item.errorActivo
          if(item.errorActivo) item.errormessages = `La hora ingresada se debe encontrar en el rango de ${this.editedItem.inicio} y ${this.editedItem.fin}` ;
          else item.errorMessages = null
        }
      });
    }
  },
}
</script>

<style>
.small-texto {
  font-size: 0.8em;
  color: red;
}
</style>